<template>
    <div>
        <slide-over-panel   v-model:show="showArchiveBeforePanel"
        >
            <template #title>
                Archive Data Before
            </template>

            <template #content>
                <span   v-if="selectedRow !== null"
                        class="text-base">
                    Archiving Data on {{ getPoint(data[selectedRow]).name ? getPoint(data[selectedRow]).name : ''}}
                        ({{ data[selectedRow] ? data[selectedRow].serial_number : '' }}) before...
                </span>

                <device-settings-archive-before     v-model:device-id="selectedDeviceId"
                                                    :timezone="timezone"

                ></device-settings-archive-before>
            </template>
        </slide-over-panel>
    </div>

    <div class="flex justify-center w-full">
        <div>
            <!-- Contents -->
            <ajax-table     v-model:items-per-page="ajaxTable.itemsPerPage"
                            v-model:loading="ajaxTable.loading"
                            v-model:page="ajaxTable.page"
                            v-model:page-info="ajaxTable.pageInfo"
                            v-model:search="ajaxTable.search"
                            v-model:sort-by="ajaxTable.sortBy"
                            v-model:sort-desc="ajaxTable.sortDesc"
                            :data="data"
                            :exportable="false"
                            :headers="headers"
                            class="overflow-visible -mt-16"
                            @loadData="getData"
                            @rowSelected="showDetailsPanel">

                <template #search-right>
                    <div class="flex items-center gap-2 ml-2 mb-4">
                        <select v-model="ajaxTable.sortBy"
                                class="border rounded border-gray-300 bg-white py-2 px-3 pr-8 text-gray-800 leading-normal text-base cursor-pointer">
                            <option value="">Sort By...</option>
                            <option v-for="option in sortOptions"
                                    :key="option.value"
                                    :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>

                        <button v-if="ajaxTable.sortBy"
                                type="button"
                                class="border rounded shadow border-gray-300 bg-white p-2 text-gray-500 hover:text-gray-800 cursor-pointer"
                                :title="ajaxTable.sortDesc ? 'Descending' : 'Ascending'"
                                @click="ajaxTable.sortDesc = !ajaxTable.sortDesc">
                            <svg class="h-5 w-5"
                                 fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path v-if="!ajaxTable.sortDesc"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M3 4h13M3 8h9M3 12h5m4 0l4-4m0 0l4 4m-4-4v12" />
                                <path v-else
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M3 4h13M3 8h9M3 12h9m4 0l4 4m0 0l-4 4m4-4H9" />
                            </svg>
                        </button>
                    </div>
                </template>

                <!-- Location Column -->
                <template   #col-1="props">
                    <div    class="flex flex-col">
                        <!-- Area -->
                        <div>
                            <undecorated-link   v-if="getArea(props.row)"
                                                :href="company.buildCompanyRoute(`floorplan?area_id=${getArea(props.row).id}`)"
                                                class="text-sm text-gray-900 hover:underline"
                                                @click.stop>
                                {{ getArea(props.row).name }}</undecorated-link>
                            <span   v-else> - </span>
                        </div>

                        <!-- Zone -->
                        <div>
                            <undecorated-link   v-if="getArea(props.row)"
                                                :href="company.buildCompanyRoute(`floorplan?area_id=${getArea(props.row).id}`)"
                                                class="text-sm text-gray-500 hover:underline"
                                                @click.stop>
                                {{ getZone(props.row).name }}</undecorated-link>
                            <span   v-else> - </span>
                        </div>
                    </div>
                </template>

                <!-- Point Column -->
                <template   #col-2="props">
                    <div    class="flex flex-col">
                        <!-- Point with Link to View Point -->
                        <div>
                            <undecorated-link   v-if="getPoint(props.row)"
                                                :href="company.buildCompanyRoute(`meters/${getPoint(props.row).id}`)"
                                                class="text-sm text-gray-900 hover:underline"
                                                @click.stop>
                                {{ getPoint(props.row).name }}</undecorated-link>
                            <span   v-else> - </span>
                        </div>

                        <!-- Serial Number & Alias Serial  -->
                        <div>
                            <undecorated-link   v-if="getPoint(props.row)"
                                                :href="company.buildCompanyRoute(`meters/${getPoint(props.row).id}/edit`)"
                                                class="text-sm text-gray-500 hover:underline"
                                                @click.stop>
                                {{ props.row.serial_number }} ({{ props.row.alias_serial }})</undecorated-link>
                            <span   v-else> - </span>
                        </div>
                    </div>
                </template>

                <!-- Latest Reading & Post -->
                <template   #col-3="props">
                    <div    class="flex flex-col">
                        <span   class="text-sm text-gray-900">{{ props.row.mostRecentCheckin === null ? '-' : props.row.mostRecentCheckin.time }}</span>
                        <span   class="text-sm text-gray-500">{{ props.row.mostRecentCheckin === null ? '-' : props.row.mostRecentCheckin.data }}</span>
                    </div>
                </template>

                <!-- Source IP:Port -->
                <template   #col-4="props">
                    <span   class="text-sm text-gray-900">{{ props.row.transfer_protocol }}:{{ props.row.ip_address }}:{{ props.row.port }}</span>
                </template>

                <!-- Version -->
                <template   #col-5="props">
                    <div    class="flex items-center">
                        <span   >{{ props.row.device_type }}</span>
                        <span   v-if="props.row.device_type !== null">@</span>
                        <span   class="text-sm text-gray-900">{{ props.row.version }}</span>
                    </div>
                </template>
            </ajax-table>
        </div>
            <!--
            -->

        </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import AjaxTable from "@/components/elements/AjaxTable.vue";
import SlideOverPanel from "@/components/elements/SlideOverPanel.vue";
import DeviceSettingsArchiveBefore from "@/components/DeviceSettings/DeviceSettingsArchiveBefore.vue";
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";

export default {
    name: "DeviceSettingsIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin],
    components: {UndecoratedLink, DeviceSettingsArchiveBefore, SlideOverPanel, AjaxTable},
    emits: [],
    props: {
        // Props
        timezone: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            data: [],
            headers: [
                {
                    name: 'Location',
                    sortBy: '',
                    key: 'location',
                },
                {
                    name: 'Point',
                    sortBy: '',
                    key: 'point',
                },
                {
                    name: 'Current Reading & Last Post Time',
                    sortBy: '',
                    key: '',
                },
                {
                    name: 'Source IP:Port',
                    sortBy: '',
                    key: '',
                },
                {
                    name: 'Version',
                    sortBy: '',
                    key: '',
                },
            ],
            sortOptions: [
                { label: 'Area', value: 'area_name' },
                { label: 'Zone', value: 'zone_name' },
                { label: 'Point Name', value: 'point_name' },
                { label: 'Serial Number', value: 'serial_number' },
                { label: 'Last Post Time', value: 'last_post_time' },
            ],
            requestNumber: 0,
            selectedRow: null,

            showArchiveBeforePanel: false,
            // Should be the selected device id
            selectedDeviceId: null,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        // Methods
        getData() {
            this.data = []
            this.requestNumber++
            this.ajaxTable.loading = true
            let params = JSON.parse(JSON.stringify(this.ajaxTable))
            params.requestNumber = this.requestNumber

            axios.get(this.company.buildCompanyApiInternalRoute(`device-settings`), {
                params: params,
            }).then(response => {
                let data = response.data
                if (`${this.requestNumber}` !== `${data.meta.requestNumber}`) {
                    return
                }

                this.ajaxUpdateTableData(data)
                this.data = ! _.isNil(data) ? data.data : []
            })
            .catch(error => {
                console.error("There was an error!", error)
            }).then(() => {
                this.ajaxTable.loading = false
            })

        },
        showDetailsPanel(rowIndex) {
            // If the archive before panel is already showing, do nothing
            if (this.showArchiveBeforePanel) {
                return
            }

            this.selectedRow = rowIndex
            this.selectedDeviceId = this.data[rowIndex].id
            this.showArchiveBeforePanel = true
        },
        getPoint(device) {
            let meter = device.meter
            if (_.isNil(meter)) {
                return null
            }

            return device.meter
        },
        getZone(device) {
            let point = this.getPoint(device)
            if (_.isNil(point)) {
                return null
            }

            return point.zone
        },
        getArea(device) {
            let zone = this.getZone(device)
            if (_.isNil(zone)) {
                return null
            }

            return zone.area
        },
    },
    computed: {},
    watch: {
        selectedRow(val) {
            // If the selected row is set to null, hide the panel & clear the selected Device
            if (_.isNil(val)) {
                this.selectedDeviceId = null
                this.showArchiveBeforePanel = false
            }
        },
        selectedDeviceId(val) {
            // If the selected device id is set to null, hide the panel & clear the selected row
            if (_.isNil(val)) {
                this.selectedRow = null
                this.showArchiveBeforePanel = false
            }
        },
    },
}
</script>

<style scoped>

</style>